export const misDistHeatWaveConfig = {
  colKey1: "",
  colKey2: "",
  colKey3: "block_name",
  colKey4: "no_of_deaths",
  colKey5: "no_of_deaths_cum",
  colKey6: "no_of_injured_persons",
  colKey7: "no_of_injured_persons_cum",
  colKey8: "no_of_houses_fully_damaged",
  colKey9: "no_of_houses_fully_damaged_cum",
  colKey10: "no_of_houses_partially_damaged",
  colKey11: "no_of_houses_partially_damaged_cum",
  colKey12: "no_of_people_rescued",
  colKey13: "no_of_people_rescued_cum",
  colKey14: "no_of_relief_camps",
  colKey15: "no_of_relief_camps_cum",
  colKey16: "remarks",
};

export const misColumns = Object.entries(misDistHeatWaveConfig).map(
  ([key, value], index) => ({
    Header: `misdistearthquakereport.headercol${index + 1}`,
    accessor: value,
    disableSortBy: true,
    showInitially: true,
  })
);